module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', [_c('el-row', [_c('el-alert', {
    attrs: {
      "title": "详情",
      "description": "资质详情展示如下",
      "type": "success",
      "closable": false,
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.form.credentialArr), function(v, index) {
    return _c('el-card', {
      key: index,
      staticStyle: {
        "width": "40%",
        "display": "inline-block",
        "margin": "20px"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(255, 145, 0)",
        "font-weight": "600"
      }
    }, [_vm._v(_vm._s(v.title) + "信息:")])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "证照名称:"
      }
    }, [_c('el-input', {
      attrs: {
        "readonly": "",
        "maxlength": 200,
        "placeholder": ""
      },
      model: {
        value: (v.title),
        callback: function($$v) {
          _vm.$set(v, "title", $$v)
        },
        expression: "v.title"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "证照编号:"
      }
    }, [_c('el-input', {
      attrs: {
        "readonly": "",
        "maxlength": 200,
        "placeholder": ""
      },
      model: {
        value: (v.license_no),
        callback: function($$v) {
          _vm.$set(v, "license_no", $$v)
        },
        expression: "v.license_no"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "证照文件地址:"
      }
    }, [_c('el-input', {
      attrs: {
        "readonly": "",
        "placeholder": ""
      },
      model: {
        value: (v.url),
        callback: function($$v) {
          _vm.$set(v, "url", $$v)
        },
        expression: "v.url"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "证照开始日期:"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(v.begin_date, 'yyyy-MM-dd hh:mm:ss')))])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "证照结束日期:"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(v.end_date, 'yyyy-MM-dd hh:mm:ss')))])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-form-item', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "warning",
              "size": "mini"
            }
          }, [_c('a', {
            staticStyle: {
              "color": "azure"
            },
            attrs: {
              "href": v.url,
              "download": v.title + '.jpg'
            }
          }, [_vm._v("下载文件")])]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "primary",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.handleEditDistribution(v.url)
              }
            }
          }, [_vm._v("预览资质")])]
        }
      }], null, true)
    }), _vm._v(" "), [_c('el-dialog', {
      attrs: {
        "title": "资质图片",
        "visible": _vm.dialogFormVisible,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-popover', {
      attrs: {
        "placement": "top",
        "width": "500",
        "trigger": "click"
      },
      scopedSlots: _vm._u([{
        key: "reference",
        fn: function() {
          return [_c('img', {
            staticStyle: {
              "cursor": "pointer",
              "width": "50%",
              "height": "50%"
            },
            attrs: {
              "src": _vm.imgUrl
            },
            on: {
              "click": function($event) {
                _vm.popoverVisible = true
              }
            }
          })]
        },
        proxy: true
      }], null, true),
      model: {
        value: (_vm.popoverVisible),
        callback: function($$v) {
          _vm.popoverVisible = $$v
        },
        expression: "popoverVisible"
      }
    }, [_c('img', {
      style: (_vm.imageStyle),
      attrs: {
        "src": _vm.imgUrl
      },
      on: {
        "click": _vm.rotateImage
      }
    })])], 1)], 1)]], 2)
  }), 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f20c56f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f20c56f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/zizhi/detail.vue
// module id = 2979
// module chunks = 0